import { useEffect } from "react";

import { useDebouncedState } from "@shared";

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const { debouncedValue, setValue } = useDebouncedState(value, delayMs);

  useEffect(() => {
    setValue(value);
  }, [value, setValue]);

  return debouncedValue;
}
